// ============================================================================
// view.cattleforecast — migrated off the global read
// ============================================================================
// The forecast editor's whole render input is now owned by the scoped
// cattle.forecast.core resource. It includes both the projection inputs and
// the editor-only rows used by the Include Heifers CowDetail expansion, so the
// surface has no hidden page-local read fanout or legacy.all remainder.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'view.cattleforecast',
  obligations: Object.freeze([Object.freeze({id: 'cattle.forecast.core', owner: 'permanent'})]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
